export const STORAGE_MARSHAL_SERVICE_TOKEN = Symbol('STORAGE_MARSHAL_SERVICE_TOKEN');

export interface IStorageMarshalService {
  set item(item: { key: string; value?: string; json?: object; boolean?: boolean });
  get item(): {
    value: <G = string>(key: string) => G | null;
    number: (key: string) => number | null;
    boolean: (key: string) => boolean;
    json: <T extends object>(key: string) => T;
  };
  hasKey(key: string): boolean;
}
